import Image from 'next/image';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
const SubscriptionListEmpty: FC = () => {
  const router = useRouter();
  return <div className="my-auto flex h-full flex-col items-center justify-center" data-sentry-component="SubscriptionListEmpty" data-sentry-source-file="SubscriptionListEmpty.tsx">
      <div className="mx-auto flex justify-center">
        <Image src={`${FILE_BROWSER_URL}/img/books.webp`} width={204} height={216} alt="nodata" data-sentry-element="Image" data-sentry-source-file="SubscriptionListEmpty.tsx" />
      </div>
      <div className="mb-3 text-center text-lg font-bold">هنوز اشتراکی فعال ندارید!</div>
      <div className="mx-auto max-w-[450px] text-center text-blackThree">
        هنوز اشتراکی خریداری نکرده‌اید. با تهیه اشتراک می‌توانید به تمام دوره‌ها، منابع ویژه و امکانات پیشرفته دسترسی داشته
        باشید. همین حالا اشتراک خود را فعال کنید و از تجربه‌ی کامل یادگیری بهره‌مند شوید!
      </div>
      <div className=" w-full max-w-[450px]">
        <Button onClick={() => router.push(LINKS.SUBSCRIPTION.MAIN)} className="mr-0 mt-8 w-full  " variant="shadow" color="BLUE_BOLD" size="middle" radius="round" bold data-sentry-element="Button" data-sentry-source-file="SubscriptionListEmpty.tsx">
          خرید اشتراک
        </Button>
      </div>
    </div>;
};
export default SubscriptionListEmpty;